import { TDispatch, TGetState } from '../../types';
import { IUserBalance } from './types';
import { packageContext } from '../../contexts/package/packageContext';
import { IThunkContext } from '../../types/thunk';
import { sendEvent } from '../../utils/sendEvent';
import { setBuyPackageModalError } from '../../slices';

export const buyPackageWithHold =
  (userBalance: IUserBalance) => async (dispatch: TDispatch, getState: TGetState, extra: IThunkContext) => {
    const { httpApi } = extra;

    const state = getState();

    const response = await packageContext.buyWithHold(state, userBalance, { httpApi });

    if (response.isSuccess && response.transactionId) {
      sendEvent('payment-widget/before-payment-success', response.transactionId);
    } else {
      dispatch(setBuyPackageModalError(response.message!));

      sendEvent('payment-widget/before-payment-fail');
    }
  };
